import type { FieldError, FieldErrors, FieldValues, Path } from "react-hook-form"

/**
 * Resolve the error message to show for a field.
 * Prefers the message from react-hook-form's `errors` object; falls back to
 * the static `fallback` string passed in from the parent component.
 */
export const extractErrorMessage = (
  errors: FieldErrors | undefined,
  name: string,
  fallback: string
): string => {
  const error = errors?.[name]
  return (error as { message?: string } | undefined)?.message || fallback
}

export function fieldError<TFieldValues extends FieldValues>(
  errors: FieldErrors<TFieldValues> | undefined,
  name: Path<TFieldValues>
): FieldError | undefined {
  const fields = name.split(".")
  let current: unknown = errors
  for (const field of fields) {
    if (!current || typeof current !== "object") return undefined
    current = (current as Record<string, unknown>)[field]
  }
  return current as FieldError | undefined
}
